import { ValidationRuleDTO } from "../DTO/validationRuleDTO";
import { FieldDefinition } from "./fieldDefinition";
import { ValidationField } from "./validationField";
import { ValidationRuleDefinition } from "./validationRuleDefinition";

export class ValidationRule{

    public id!: number;
    public inputFieldReference!: ValidationField;
    public inputField!: FieldDefinition;
    public validationRuleDefinitionId!: number;
    public validationRuleDefinition!: ValidationRuleDefinition;
    public validationParameter1!: string;
    public validationParameter2!: string;
    public severity!: number;
    public validationMessage!: string;

    public createInputField(fieldDefinitions:FieldDefinition[]){
        if(this.inputFieldReference) {
            this.inputField = fieldDefinitions.find(f=>f.index==this.inputFieldReference.index)!;
        }
    }

    public static mapFromDTO(param:ValidationRuleDTO):ValidationRule{ 
        if (!param) throw new Error("parameter is null")
        let obj = new ValidationRule();
        try
        {
            obj.id = param.id;
            if(param.inputFieldReference){
                obj.inputFieldReference = JSON.parse(param.inputFieldReference);
            } 
            obj.validationRuleDefinitionId = param.validationRuleDefinitionId;
            obj.validationParameter1 = param.validationParameter1;
            obj.validationParameter2 = param.validationParameter2;
            obj.severity = param.severity;
            obj.validationMessage = param.validationMessage;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:ValidationRule):ValidationRuleDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new ValidationRuleDTO();
        try
        {
            dto.id = param.id;
            if(param.inputField) dto.inputFieldReference = JSON.stringify(param.inputField.filterField);
            dto.validationRuleDefinitionId = param.validationRuleDefinition.id;
            dto.validationParameter1 = param.validationParameter1;
            dto.validationParameter2 = param.validationParameter2;
            dto.severity = param.severity;
            dto.validationMessage = param.validationMessage;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }
}